import Head from "next/head";
import React from "react";

import WordpressApi, { Menus } from "../../services/wordpressApi";
import Home from "../[...slug]";

export default Home;

export async function getServerSideProps({
  resolvedUrl,
  params: { slug },
  ...rest
}: any) {
  let data: any;
  let menus = {};
  let htmlHead = "";

  try {
    [data, menus] = await Promise.all([
      WordpressApi.getPage(slug[slug.length - 1], "en"),
      WordpressApi.getMenus("en"),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
  if (data.blocks === undefined) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      data: data.blocks,
      tags: data.tags,
      breadcrumbs: data?.breadcrumbs,
      htmlHead: data?.htmlHead,
      menus,
      translatedSlugs: data?.translatedSlugs || {},
      lang: "en",
    },
  };
}
